export const styles = {
  card: {
    border: "1px solid",
    borderColor: "events.grayShade1",
    borderRadius: "5px",
    maxWidth: "278px",
    width: "100%",
    backgroundColor: "events.whiteTertiary",
    "& .MuiCardContent-root": {
      padding: "24px",
    },
  },
};
